import { createContext, useContext, useState } from "react";

// Default: intro NOT active (other routes show the navbar logo normally)
const IntroContext = createContext({ introActive: false, endIntro: () => {} });

export const useIntro = () => useContext(IntroContext);

export function IntroProvider({ children }) {
  const [introActive, setIntroActive] = useState(true);
  return (
    <IntroContext.Provider value={{ introActive, endIntro: () => setIntroActive(false) }}>
      {children}
    </IntroContext.Provider>
  );
}
